import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PersistConfig, persistReducer } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';

import { IUserState } from 'types/store/user';
import { IUser } from 'types/user';

const initialState: IUserState = {
  user: null,
};

export const userSlice = createSlice({
  initialState,
  name: 'user',
  reducers: {
    logoff: () => {
      return { ...initialState };
    },
    setUser: (state, { payload }: PayloadAction<IUser | null>) => {
      state.user = payload;
    },
  },
});

const loginConfig: PersistConfig<IUserState> = {
  key: 'user',
  stateReconciler: autoMergeLevel2,
  storage,
};

export const userReducer = persistReducer(loginConfig, userSlice.reducer);
